import { initializeApp } from "firebase/app";
import { getMessaging, getToken, deleteToken, onMessage } from "firebase/messaging";
import { serverUrl } from "./store/api/CommonFunctions";
const firebaseConfig = {
  apiKey: "AIzaSyAyNsxbpXHAZjElUCsGK7XJDxXa9iZSRKQ",
  authDomain: "bihamta-horma.firebaseapp.com",
  databaseURL: "https://bihamta-horma.firebaseio.com",
  projectId: "bihamta-horma",
  storageBucket: "bihamta-horma.appspot.com",
  messagingSenderId: "556975096766",
  appId: "1:556975096766:web:a2567562a773b4d5092fef"
};

const firebaseApp = initializeApp(firebaseConfig);
export const messaging = getMessaging(firebaseApp);

export function getfirebaseToken(serverURL, authToken, setTokenFound) {
  const firebaseToken = localStorage.getItem("FirebaseToken");
  if (firebaseToken?.length > 0) {
    fetch(serverUrl + `ActiveDeviceAPI/CheckTokenValidity?token=${firebaseToken}`, {
      headers: {
        "Token": authToken
      }
    }).then(res => res.json().then(res=> {
      if (!res.Data || res.Data === "false") {
        getToken(messaging, { vapidKey: 'BPjo00JmJd3iJDCDBSVqcANwLtFSC5K_doe2DaiLEbyG8_2QmF15ZcGZU0ccpEauzldL8GRJVQyO0TPN3YM__Ek' })
          .then((currentToken) => {
            if (currentToken) {
              fetch(serverURL + "ActiveDeviceAPI/SaveActiveDevice?PlayerID=" + currentToken, {
                headers: {
                  "Token": authToken
                }
              });
              localStorage.setItem("FirebaseToken", currentToken);
            } else {
              console.log('No registration token available. Request permission to generate one.');
              if (setTokenFound) {
                setTokenFound(false);
              }
            }
          }).catch((err) => {
            console.log('An error occurred while retrieving token. ', err);
          });
      }
    }))
  }
  else{

  /*return*/ getToken(messaging, { vapidKey: 'BPjo00JmJd3iJDCDBSVqcANwLtFSC5K_doe2DaiLEbyG8_2QmF15ZcGZU0ccpEauzldL8GRJVQyO0TPN3YM__Ek' })
  .then((currentToken) => {
    if (currentToken) {
      fetch(serverURL + "ActiveDeviceAPI/SaveActiveDevice?PlayerID=" + currentToken, {
        headers: {
          "Token": authToken
        }
      });
      localStorage.setItem("FirebaseToken", currentToken);

    } else {
      console.log('No registration token available. Request permission to generate one.');
      if (setTokenFound) {
        setTokenFound(false);
      }
    }
  }).catch((err) => {
    console.log('An error occurred while retrieving token. ', err);
  });
  }
}
// onMessage(messaging, (payload) => {
//   console.log('Message received. ', payload);
//   // ...
// });
